'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Select = function Select(_ref) {
  var className = _ref.className,
      name = _ref.name,
      children = _ref.children,
      label = _ref.label,
      _ref$id = _ref.id,
      id = _ref$id === undefined ? (0, _utils.idGen)('select') : _ref$id,
      onChange = _ref.onChange,
      value = _ref.value,
      defaultValue = _ref.defaultValue;

  var handleChange = function handleChange(e) {
    var targetValue = e.target.value;

    var newValue = (0, _utils.parse)(targetValue);
    e.preventDefault();
    if (onChange) {
      onChange(newValue);
    }
  };

  return _react2.default.createElement(
    'div',
    { className: 'luna-form__field' },
    _react2.default.createElement(
      'label',
      { className: 'luna-label', htmlFor: id },
      label
    ),
    _react2.default.createElement(
      'select',
      {
        className: (0, _classnames2.default)(['luna-select', className]),
        name: name,
        id: id,
        onChange: handleChange,
        value: value && (0, _utils.stringify)(value),
        defaultValue: defaultValue && !value && (0, _utils.stringify)(defaultValue)
      },
      children
    )
  );
};

Select.propTypes = {
  children: _propTypes2.default.node.isRequired,
  label: _propTypes2.default.string,
  id: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  value: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.number]),
  defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.number])
};

exports.default = Select;


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Select/Select.js